import { render, staticRenderFns } from "./TitleSmallMono.vue?vue&type=template&id=4288312e&scoped=true&"
import script from "./TitleSmallMono.vue?vue&type=script&lang=js&"
export * from "./TitleSmallMono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288312e",
  null
  
)

export default component.exports